<template>
  <div>
    <el-select :disabled="disabled" :size="size" v-model="value" placeholder="请选择" @change="handleChange" clearable style="display: block">
      <el-option v-for="(item, index) of options" :key="index" :label="item.name" :value="item.id"></el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: 'componentsCustomerTag',
  model: {
    prop: 'id',
    event: 'change'
  },
  props: {
    id: {
      type: [String, Number]
    },
    size: {
      type: String,
      default: 'small'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    id: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.value = newVal;
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.getData();
  },
  data() {
    return {
      value: '',
      options: []
    };
  },
  methods: {
    // 选择
    handleChange() {
      this.$emit('change', this.value);
    },
    //获取数据
    async getData() {
      await this.$api.customerTag.list({}).then(res => {
        if (res.code == 200 && res.data) {
          this.options = res.data;
        }
      });
    }
  }
};
</script>
